var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#052c3f;}.cls-2{fill:#95d9d0;}.cls-3{fill:#4fc0b0;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "rgb - h and square - primary") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: -1,
    width: 402,
    height: 401
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M181.62,214.38a4,4,0,0,0-4,4V269.5H163.25a14.36,14.36,0,0,1-14.37-14.38V205.86a40.46,40.46,0,0,0,5.81,6.33,41.37,41.37,0,0,0,6.56,4.72l.14.06a1.64,1.64,0,0,0,.22.14l.27.15a4,4,0,0,0,2,.51,4,4,0,0,0,1.95-7.49l-.3-.17-.12-.05-.11-.08a32.84,32.84,0,0,1-12-12,32.69,32.69,0,0,1-4.39-16.38,4,4,0,0,0-8,0v73.5a22.36,22.36,0,0,0,22.37,22.38h18.37a4,4,0,0,0,4-4V218.38A4,4,0,0,0,181.62,214.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M252.57,129.05a22.23,22.23,0,0,0-15.82-6.55H218.38a4,4,0,0,0-4,4v55.12a4,4,0,0,0,4,4,32.36,32.36,0,0,1,12.2,2.37,34.69,34.69,0,0,1,3.59,1.7h0l.05,0,.3.17h0l.11.07.06,0,0,0a32.84,32.84,0,0,1,12,12,32.69,32.69,0,0,1,4.39,16.38,4,4,0,0,0,8,0v-73.5A22.23,22.23,0,0,0,252.57,129.05Zm-1.45,65.09a40.58,40.58,0,0,0-12.27-11h0l-.05,0,0,0h0l-.41-.24-.23-.13a41.31,41.31,0,0,0-4.53-2.15,40.05,40.05,0,0,0-11.19-2.75V130.5h14.37a14.36,14.36,0,0,1,14.37,14.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M259.12,277.5H236.75a22.4,22.4,0,0,1-22.37-22.38v-26a6.77,6.77,0,0,0-6.77-6.76h-26a40.79,40.79,0,0,1-19.73-5.11l-.22-.12-.46-.26a41.38,41.38,0,0,1-6.52-4.7,40.7,40.7,0,0,1-13.81-30.57V122.5h22.37a22.36,22.36,0,0,1,22.37,22.38V174a3.63,3.63,0,0,0,3.63,3.62h29.13a40.36,40.36,0,0,1,15.19,2.95,41.31,41.31,0,0,1,4.53,2.15l.23.13.46.26a41.56,41.56,0,0,1,6.52,4.7,40.7,40.7,0,0,1,13.81,30.57Zm-110.24-147v51.12A32.78,32.78,0,0,0,165.25,210l.09.05.21.12.28.16a32.71,32.71,0,0,0,15.79,4.07h26a14.78,14.78,0,0,1,14.77,14.76v26a14.39,14.39,0,0,0,14.37,14.38h14.37V218.38A32.78,32.78,0,0,0,234.75,190l-.09-.05a2.25,2.25,0,0,0-.21-.12l-.28-.16a34.69,34.69,0,0,0-3.59-1.7,32.36,32.36,0,0,0-12.2-2.37H189.25A11.64,11.64,0,0,1,177.62,174V144.88a14.36,14.36,0,0,0-14.37-14.38Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavLogo);
export default __webpack_public_path__ + "static/media/nav-logo.a9aa892956411e3f846a090642aa2d6c.svg";
export { ForwardRef as ReactComponent };